import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClientStore } from "../store";

const CONFIG = {
  firstVisitPlaybackRate: 1.5,
  returnVisitPlaybackRate: 7,
  delayBeforeBlurMs: 250,
};

export function LandingPageBackground() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const landingVideoComplete = useClientStore((s) => s.landingVideoComplete);
  const setLandingVideoComplete = useClientStore(
    (s) => s.setLandingVideoComplete
  );

  // If video already completed this session, skip it entirely
  const [videoEnded, setVideoEnded] = useState(() => landingVideoComplete);

  const [isFirstVisit] = useState(() => {
    return localStorage.getItem("selca-visited") !== "true";
  });

  useEffect(() => {
    localStorage.setItem("selca-visited", "true");
  }, []);

  useEffect(() => {
    if (videoRef.current && !videoEnded) {
      videoRef.current.playbackRate = isFirstVisit
        ? CONFIG.firstVisitPlaybackRate
        : CONFIG.returnVisitPlaybackRate;
    }
  }, [isFirstVisit, videoEnded]);

  const handleVideoEnd = () => {
    setTimeout(() => {
      setVideoEnded(true);
      setLandingVideoComplete(true);
    }, CONFIG.delayBeforeBlurMs);
  };

  return (
    <div className="fixed inset-0 z-0 overflow-hidden">
      <motion.div
        animate={{ opacity: 1, filter: videoEnded ? "blur(8px)" : "blur(0px)" }}
        className="absolute inset-0"
        initial={{ opacity: 1, filter: "blur(0px)" }}
        transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
      >
        <img
          alt=""
          className="h-full w-full object-cover"
          src="/empty_background_image.png"
        />
      </motion.div>

      <AnimatePresence>
        {!videoEnded && (
          <motion.video
            autoPlay
            className="absolute inset-0 h-full w-full object-cover"
            exit={{ opacity: 0 }}
            initial={{ opacity: 1 }}
            key="video"
            muted
            onEnded={handleVideoEnd}
            playsInline
            ref={videoRef}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <source src="/polar_bear_disappearing.mp4" type="video/mp4" />
          </motion.video>
        )}
      </AnimatePresence>
    </div>
  );
}
